import {
  FORM_CONTROLLER_ID,
  LIGHTBOX_CONTROLLER_ID,
  FocusClass,
  HashLinkFix,
  initializer,
  JSAttr,
  PageUpdater,
  Toggle,
  DATEPICKER_CONTROLLER_ID,
  Tabs,
  ViewportHeight,
} from 'js-common';

import {
  INTRO_CONTROLLER_ID,
  EVALUATION_FORM_CONTROLLER_ID,
  EVENT_FORM_CONTROLLER_ID,
  EVENT_FILTER_CONTROLLER_ID,
  FORM_MODAL_CONTROLLER_ID,
  PAGE_SPINNER_CONTROLLER_ID,
  TABLE_CONTROLLER_ID,
} from './constants';

import Messages from './Messages';
import Menu from './Menu';

initializer
  .register([
    FocusClass,
    HashLinkFix,
    JSAttr,
    Toggle,
    PageUpdater,
    Messages,
    Tabs,
    ViewportHeight,
    Menu,
    [
      INTRO_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'Intro' */ './Intro'),
    ],
    [
      FORM_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'Form' */ 'js-common/Form'),
    ],
    [
      DATEPICKER_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'Datepicker' */ 'js-common/Datepicker'),
    ],
    [
      EVALUATION_FORM_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'Evaluation' */ './Evaluation'),
    ],
    [
      EVENT_FORM_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'EventForm' */ './EventForm'),
    ],
    [
      EVENT_FILTER_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'EventFilter' */ './EventFilter'),
    ],
    [
      FORM_MODAL_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'FormModal' */ './FormModal'),
    ],
    [
      LIGHTBOX_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'Lightbox' */ 'js-common/Lightbox'),
    ],
    [
      PAGE_SPINNER_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'PageSpinner' */ './PageSpinner'),
    ],
    [
      TABLE_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'Table' */ './Table'),
    ],
  ])
  .init();
